import type { RouteRecordRaw } from 'vue-router'

const contactsRoutes: RouteRecordRaw = {
  path: '/contacts',
  name: 'contacts',
  meta: { layout: 'DashboardLayout', requiresAuth: true, title: 'contact.titles.contacts' },
  component: () => import('@/pages/contacts/ContactsPage.vue'),
}

export default contactsRoutes
